import { keyframes } from '@mui/material/styles';

/**
 * Animation keyframes for Feature Studio components.
 * Used for spinner rotation, generating card effects, and progress bars.
 */

// Spinner rotation (1s linear infinite)
export const fsSpin = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

// Top edge sweep on generating cards (1.6s linear infinite)
export const fsSweep = keyframes`
  0% { transform: translateX(-100%); }
  100% { transform: translateX(100%); }
`;

// Bottom progress bar (1.8s ease-in-out infinite)
export const fsBar = keyframes`
  0% { transform: translateX(-100%); }
  50% { transform: translateX(60%); }
  100% { transform: translateX(260%); }
`;
